import {
  Button,
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
  MenuItem,
  IconButton,
  Chip,
  CardContent,
  List,
  Divider,
  ListItem,
} from "@mui/material";
import { useStyles } from "../../../theme/appStyles";
import React, { useEffect, useMemo, useState } from "react";
import { CircularProgress, Grid, Box, Typography } from "@mui/material";
import {
  useChangeStatusOrderListSentToManagerMutation,
  useGetAllGetOrderListHistoryQuery,
  useGetOrderListByIdQuery,
  useGetUserInfoOnyQuery,
  useAdminChangeStatusMutation,
  useAdminConformStorePriceQuery,
  useGetStoreQuery,
  useGetProductQuery,
} from "../../../Api/attoDeskApi";
import {
  IOrderListPriceEdit,
  IOrderList,
  IUserAdmin,
  IStore,
  IProductPopUP,
  IStoreItemAdminEdit,
} from "../../../Api/Interface/api.interface";
import { useParams } from "react-router-dom";
import { OrderListStatus, SizeOfLevelType } from "../../../Core/Enum/enum";
import LogoMain from "../../../Images/logo.webp";
import TableViewIcon from "@mui/icons-material/TableView";
import LocalPrintshopSharpIcon from "@mui/icons-material/LocalPrintshopSharp";
import dayjs, { Dayjs } from "dayjs";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import { useNavigate } from "react-router-dom";
import { useNotifier } from "../../../Core/Notifier";
import StatusPopup from "../../../Components/Delete/StatusPopup";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useFormik } from "formik";
import NewPopUpProduct from "../../Product/Edit/orderListItemEdit";
import { CiEdit } from "react-icons/ci";

const convertUnit = (unit: number) => {
  switch (unit) {
    case SizeOfLevelType.kg:
      return "kg";
    case SizeOfLevelType.small:
      return "small";
    case SizeOfLevelType.li:
      return "li";
    case SizeOfLevelType.Medium:
      return "Medium";
    case SizeOfLevelType.Bottle:
      return "Bottle";
    case SizeOfLevelType.Each:
      return "Each";
    case SizeOfLevelType.Large:
      return "Large";
    case SizeOfLevelType.case:
      return "Case";
    default:
      return "";
  }
};

const convertStatus = (unit: string): string => {
  switch (unit) {
    case "OrderListCreated":
      return "Order List Created";
    case "SentToManager":
      return "Sent To Manager";
    case "ManagerApproved":
      return "Approved";
    case "ManagerConfirmed":
      return "Confirmed";
    case "Processed":
      return "Processed";
    case "Completed":
      return "Completed";
    case "Rejected":
      return "Rejected";
    default:
      return "";
  }
};

const Index = () => {
  const classes = useStyles();
  const { showErrorMessage, showMessage } = useNotifier();
  const { id: orderListHistoryId } = useParams<{ id: string }>();
  const [orderList, setOrderList] = useState<IOrderListPriceEdit[]>([]);
  // const [groupedData, setGroupedData] = useState<
  //   Record<number, IOrderListPriceEdit[]>
  // >({});
  const [groupedData, setGroupedData] = useState<
    Record<string, IOrderListPriceEdit[]>
  >({});
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10000);
  const navigate = useNavigate();
  const [coursingToStatus, setCoursingToStatus] = useState<string | undefined>(
    ""
  );
  const [open, setOpen] = useState(false);
  const [openOrderListDate, setOpenOrderListDate] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState<String | undefined>(
    undefined
  );
  const [selectedProductData, setSelectedProductData] = useState<
    IProductPopUP | undefined
  >(undefined);
  const [openDialog, setOpenDialog] = useState(false);

  const {
    data: orderListData,
    isLoading: orderListIsLoading,
    isError: orderListIsError,
    refetch,
  } = useAdminConformStorePriceQuery({
    id: String(orderListHistoryId),
  });

  const {
    data: OrderListDate,
    isLoading: OrderListDateIsLoading,
    isError: OrderListDateIsError,
  } = useGetOrderListByIdQuery({
    searchText: "",
    id: String(orderListHistoryId),
  });

  // const {
  //   data: orderListData,
  //   isLoading: orderListIsLoading,
  //   isError: orderListIsError,
  //   refetch: orderListRefetch,
  // } = useGetAllGetOrderListHistoryQuery({
  //   orderId: String(orderListHistoryId),
  //   searchText: "",
  // });
  const { data: userData, isLoading: userIsLoading } = useGetUserInfoOnyQuery({
    searchText: "",
  });

  const { data: storeData, isLoading: storeIsLoading } = useGetStoreQuery({
    searchText: "",
  });

  const [newStatus, { isLoading }] = useAdminChangeStatusMutation();

  const {
    data: OrderlistEditProductIdDate,
    isLoading: OrderlistEditProductIdIsLoading,
    isError: OrderlistEditProductIdIsErrr,
  } = useGetProductQuery(
    {
      searchText: "",
      id: String(selectedProduct),
      variantBrandId: null,
      categoryId: null,
      variantTagId: null,
      productViewOnline: null,
      createdDateStart: null,
      createdDateEnd: null,
      createdDate: null,
      mainItemId: null,
    },
    {
      skip: !selectedProduct,
    }
  );

  const dataProduct = useMemo(() => {
    if (
      OrderlistEditProductIdDate &&
      Array.isArray(OrderlistEditProductIdDate.data) &&
      OrderlistEditProductIdDate.data.length > 0
    ) {
      return OrderlistEditProductIdDate.data[0] as IProductPopUP;
    }
    return undefined;
  }, [OrderlistEditProductIdDate]);

  useEffect(() => {
    if (dataProduct) {
      setSelectedProductData(dataProduct);
    }
  }, [dataProduct]);

  const orderListHisrotyRecord = useMemo(() => {
    return orderListData?.data as IOrderListPriceEdit[];
  }, [orderListData?.data]);

  const orderListDate = useMemo(() => {
    return OrderListDate?.data as IOrderList[];
  }, [OrderListDate?.data]);

  const userList = useMemo(() => {
    return userData?.data as IUserAdmin[];
  }, [userData?.data]);

  const getAllStoreList = useMemo(() => {
    return storeData?.data as IStore[];
  }, [storeData?.data]);

  const userMap = useMemo(() => {
    const map = new Map();
    userList?.forEach((category) => {
      map.set(category.id, `${category.user_role_name} - ${category.username}`);
    });
    return map;
  }, [userList]);

  const userMap2 = useMemo(() => {
    const map = new Map();
    userList?.forEach((category) => {
      map.set(category.id, `${category.user_role_name}`);
    });
    return map;
  }, [userList]);

  const getStoreMap = useMemo(() => {
    const map = new Map();
    getAllStoreList?.forEach((category) => {
      map.set(category.id, category.storeName);
    });
    return map;
  }, [getAllStoreList]);

  const ReDateId =
    orderListDate?.length > 0 ? orderListDate[0].orderListId : null;
  const createBy =
    orderListDate?.length > 0 ? orderListDate[0].created_by : null;
  const createAt =
    orderListDate?.length > 0 ? orderListDate[0].created_at : null;
  const orderListStatus =
    orderListDate?.length > 0 ? orderListDate[0].orderListStatus : null;

  // useEffect(() => {
  //   // Grouping products by store ID using minimumpriceDetails store ID
  //   const grouped: Record<number, IOrderListPriceEdit[]> = {};
  //   orderList.forEach((order) => {
  //     const storeId = order.minimumpriceDetails.storeId;
  //     if (!grouped[storeId]) {
  //       grouped[storeId] = [];
  //     }
  //     grouped[storeId].push(order);
  //   });
  //   setGroupedData(grouped);
  // }, [orderList]);

  useEffect(() => {
    // Grouping products by store ID using minimumpriceDetails store ID, handling null values
    const grouped: Record<string, IOrderListPriceEdit[]> = {};
    orderList.forEach((order) => {
      let storeId: string | number = "null";

      if (order.minimumpriceDetails) {
        // If minimumpriceDetails is available, use its storeId
        storeId = order.minimumpriceDetails.storeId;
      } else {
        // Find the lowest price from storePriceResults if minimumpriceDetails is null
        const minPriceStore = order.storePriceResults.reduce((min, store) => {
          return store.price !== null &&
            (min === null || store.price < min.price)
            ? store
            : min;
        }, null as IStoreItemAdminEdit | null);

        if (minPriceStore) {
          storeId = minPriceStore.storeId;
        }
      }

      if (!grouped[storeId]) {
        grouped[storeId] = [];
      }
      grouped[storeId].push(order);
    });
    setGroupedData(grouped);
  }, [orderList]);

  const handleOpenDialog = (productId: String) => {
    setSelectedProduct(productId);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setSelectedProduct(undefined);
    setOpenDialog(false);
    setSelectedProductData(undefined);
    refetch();
  };

  const handleExportToExcel = () => {
    const getSafeToFixed = (
      value: string | number | null | undefined
    ): string => {
      const numericValue = parseFloat(String(value));
      return !isNaN(numericValue) ? numericValue.toFixed(2) : "";
    };

    const exportData = orderList.map((row, index) => ({
      Items: row.variantName || "",
      Qty: `${row.productTotalUnit} ${convertUnit(row.variantUnit)}`,
      Remark: row.remark || "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "OrderList");
    const fileName = `OrderList_${dayjs(createAt).format("YYYY MMM, DD")}.xlsx`;

    XLSX.writeFile(workbook, fileName);
  };

  const handleExportToPDF = () => {
    const getSafeToFixed = (
      value: string | number | null | undefined
    ): string => {
      const numericValue = parseFloat(String(value));
      return !isNaN(numericValue) ? numericValue.toFixed(2) : "";
    };

    const tableData = orderList.map((row, index) => [
      row.variantName || "",
      `${row.productTotalUnit} ${convertUnit(row.variantUnit)}`,
      row.remark || "",
    ]);

    const tableHeaders = [["Items", "Qty", "Remark"]];

    const doc = new jsPDF("l", "mm", "a4");

    const imageUrl = LogoMain;
    const pageWidth = doc.internal.pageSize.width;
    const imgWidth = 50;
    const imgHeight = 12;
    // const imgX = (pageWidth - imgWidth) / 2;
    const imgY = 10;
    const imgX = 10;

    const img = new Image();
    img.src = imageUrl;

    img.onload = () => {
      doc.addImage(img, "PNG", imgX, imgY, imgWidth, imgHeight);
      const textStartY = imgY + imgHeight / 2;

      const centerText = (text: string, y: number) => {
        const textWidth = doc.getTextWidth(text);
        const textX = (pageWidth - textWidth) / 2;
        doc.text(text, textX, y);
      };

      const rightAlignText = (text: string, y: number) => {
        const textWidth = doc.getTextWidth(text);
        const textX = pageWidth - textWidth - 15;
        doc.text(text, textX, y);
      };

      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      rightAlignText(`Order List :  ${ReDateId}`, textStartY);

      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      rightAlignText(
        `Create By: ${userMap2.get(createBy) || ""}, ${dayjs(createAt).format(
          "YYYY MMM, DD"
        )}`,
        textStartY + 5
      );

      (doc as any).autoTable({
        head: tableHeaders,
        body: tableData,
        startY: textStartY + 15,
        theme: "grid",
        styles: {
          fontSize: 8,
          cellPadding: 2,
        },
        headStyles: {
          fillColor: [200, 200, 200],
          textColor: 0,
          fontStyle: "bold",
        },
        alternateRowStyles: {
          fillColor: [245, 245, 245],
        },
        tableLineColor: [0, 0, 0],
        tableLineWidth: 0.1,
      });

      const fileName = `OrderList_${dayjs(createAt).format(
        "YYYY MMM, DD"
      )}.pdf`;

      doc.save(fileName);
    };
  };

  useEffect(() => {
    if (orderListHisrotyRecord) {
      setOrderList(orderListHisrotyRecord);
    }
  }, [orderListHisrotyRecord]);

  const handleOpenStatusPopup = () => {
    setCoursingToStatus(String(orderListHistoryId));
    setOpen(true);
  };

  const handleCloseStatusPopup = () => {
    setCoursingToStatus(undefined);
    setOpen(false);
  };

  const handleOpenDialogGenerate = () => {
    setOpenOrderListDate(true);
  };

  const handleCloseDialogGenerate = () => {
    setOpenOrderListDate(false);
  };

  // const handleStoreSelection = (productId: string, storeId: number) => {
  //   setOrderList((prevOrderList) =>
  //     prevOrderList.map((item) =>
  //       Number(item.productId) === Number(productId)
  //         ? {
  //             ...item,
  //             storePriceResults: item.storePriceResults.map((store) => ({
  //               ...store,
  //               isminimumprice: store.storeId === storeId,
  //             })),
  //           }
  //         : item
  //     )
  //   );
  // };

  const handleStoreSelection = (productId: string, storeId: number) => {
    setOrderList((prevOrderList) =>
      prevOrderList.map((item) =>
        Number(item.productId) === Number(productId)
          ? {
              ...item,
              storePriceResults: item.storePriceResults.map((store) => ({
                ...store,
                isminimumprice: store.storeId === storeId,
              })),
              minimumpriceDetails:
                item.storePriceResults.find(
                  (store) => store.storeId === storeId
                ) || item.minimumpriceDetails,
            }
          : item
      )
    );
  };

  const formik = useFormik({
    initialValues: {
      id: "",
      status: "",
    },
    onSubmit: async (values, { resetForm }) => {
      try {
        const temData = {
          id: String(orderListHistoryId),
          status: values.status,
        };

        const addCompanyResponse = await newStatus(temData).unwrap();
        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
        } else {
          showMessage(addCompanyResponse.message);
          resetForm();
          setOpenOrderListDate(false);
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  const [changeStatus] = useChangeStatusOrderListSentToManagerMutation();

  const handleChangeStatus = async (id: string) => {
    try {
      const response = await changeStatus(id).unwrap();
      if (response.status) {
        showMessage(response.message);
        setOpen(false);
        navigate("/order/list");
      } else {
        showErrorMessage(response.message);
      }
    } catch (error) {
      showErrorMessage("Failed to change status");
    }
  };

  const formValid = useMemo(() => {
    return formik.values.status !== "" && formik.values.status !== undefined;
  }, [formik]);

  if (orderListIsLoading || OrderListDateIsLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Grid container spacing={3}>
      <Grid item lg={8} md={12} sm={12} xs={12}>
        <Card className={classes.stepperCard4}>
          <Grid container spacing={2} p={2}>
            {/* <Grid item lg={4} md={6} sm={6} xs={6} mb={2} >
              <Grid container>
                <img
                  src={LogoMain}
                  alt="AttoDesk Login"
                  style={{
                    width: "200px",
                    height: "60px",
                    display: "block",
                  }}
                />
              </Grid>
            </Grid> */}

            <Grid item lg={12} md={12} sm={12} xs={12} mt={10}>
              <Grid container justifyContent={"space-between"} spacing={2}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid container justifyContent={"space-between"} spacing={2}>
                    {/* <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Typography
                      textAlign={"right"}
                      className={classes.primaryHeading}
                    >
                      {convertStatus(orderListStatus || "")}
                    </Typography>
                  </Grid> */}
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <TableContainer>
                        <Table className={classes.table}>
                          <TableHead className={classes.tableHeaderRow}>
                            <TableRow>
                              <TableCell className={classes.tablheader}>
                                <strong>Items</strong>
                              </TableCell>
                              <TableCell className={classes.tablheader}>
                                <strong>Select Store</strong>
                              </TableCell>
                              <TableCell
                                className={classes.tablheader}
                                sx={{ textAlign: "center" }}
                              >
                                <strong>Confirm Store</strong>
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {orderListIsLoading ? (
                              <TableRow>
                                <TableCell colSpan={20} align="center">
                                  <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    height="10vh"
                                  >
                                    <CircularProgress />
                                  </Box>
                                </TableCell>
                              </TableRow>
                            ) : orderListIsError ? (
                              <TableRow>
                                <TableCell colSpan={20} align="center">
                                  Some thing went to wrong
                                </TableCell>
                              </TableRow>
                            ) : orderList.length === 0 ? (
                              <TableRow>
                                <TableCell colSpan={20} align="center">
                                  No data available
                                </TableCell>
                              </TableRow>
                            ) : (
                              orderList.map(
                                (row: IOrderListPriceEdit, index) => (
                                  <TableRow
                                    key={index}
                                    className={classes.tableRowHover}
                                  >
                                    <TableCell
                                      scope="row"
                                      className={classes.tablCell}
                                    >
                                      {row.variantName}
                                      {/* {" ("} {row.productTotalUnit}{" "}
                                  {convertUnit(row.variantUnit)}{")"} */}
                                    </TableCell>
                                    <TableCell
                                      scope="row"
                                      className={classes.tablCell}
                                    >
                                      {row.storePriceResults &&
                                      row.storePriceResults.length > 0 ? (
                                        <Box
                                          sx={{
                                            display: "flex",
                                            flexWrap: "wrap",
                                            gap: "10px",
                                            alignItems: "center",
                                          }}
                                        >
                                          {row.storePriceResults.map((s, i) => (
                                            <Box
                                              key={i}
                                              sx={{
                                                padding: "8px 12px",
                                                borderRadius: "8px",
                                                display: "inline-flex",
                                                alignItems: "center",
                                                backgroundColor:
                                                  s.isminimumprice
                                                    ? "#DFF6DD"
                                                    : "#FEF3C7",
                                                color: s.isminimumprice
                                                  ? "#166534"
                                                  : "#B45309",
                                                border: s.isminimumprice
                                                  ? "2px solid #22C55E"
                                                  : "2px solid #F59E0B",
                                                fontWeight: "bold",
                                                cursor: "pointer",
                                                transition: "0.3s ease-in-out",
                                                boxShadow:
                                                  "0px 2px 5px rgba(0,0,0,0.1)",
                                                minWidth: "150px",
                                                textAlign: "center",
                                                "&:hover": {
                                                  transform: "scale(1.05)",
                                                },
                                              }}
                                              onClick={() => {
                                                if (s.price > 0) {
                                                  handleStoreSelection(
                                                    row.productId,
                                                    s.storeId
                                                  );
                                                } else {
                                                  handleOpenDialog(
                                                    row.productId
                                                  );
                                                }
                                              }}
                                            >
                                              <Typography variant="body2">
                                                <strong>
                                                  {getStoreMap.get(s.storeId)}{" "}
                                                </strong>
                                                |{" "}
                                                {s.price
                                                  ? `$${s.price}`
                                                  : "N/A"}
                                              </Typography>
                                            </Box>
                                          ))}
                                        </Box>
                                      ) : (
                                        <Box
                                          sx={{
                                            display: "flex",
                                            alignItems: "center",
                                          }}
                                        >
                                          <Typography
                                            variant="body2"
                                            sx={{ color: "#888" }}
                                          >
                                            No store prices available
                                          </Typography>
                                          <IconButton
                                            sx={{ marginLeft: "8px" }}
                                            onClick={() =>
                                              handleOpenDialog(row.productId)
                                            }
                                          >
                                            <CiEdit
                                              style={{ color: "#F59E0B" }}
                                            />
                                          </IconButton>
                                        </Box>
                                      )}
                                    </TableCell>
                                    {/* 
                                <TableCell
                                  scope="row"
                                  className={classes.tablCell}
                                >
                                  {row.minimumpriceDetails ? (
                                    <Box
                                      sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "flex-start",
                                        padding: "12px",
                                        backgroundColor: "#ffffff", // White background for a clean look
                                        borderRadius: "10px",
                                        border: "1px solid #e2e8f0",
                                        boxShadow:
                                          "0 2px 8px rgba(0, 0, 0, 0.12)",
                                        transition: "0.3s ease-in-out",
                                        "&:hover": {
                                          transform: "scale(1.05)",
                                          boxShadow:
                                            "0 4px 12px rgba(0, 0, 0, 0.15)",
                                        },
                                      }}
                                    >
                                      <Typography
                                        variant="body1"
                                        sx={{
                                          fontWeight: "bold",
                                          color: "#1a202c", // Dark color for the store name
                                          marginBottom: "6px",
                                        }}
                                      >
                                        {getStoreMap.get(
                                          row.minimumpriceDetails.storeId
                                        )}
                                      </Typography>

                                      <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          marginBottom: "6px",
                                        }}
                                      >
                                        <Typography
                                          variant="h6"
                                          sx={{
                                            fontWeight: "bold",
                                            color:
                                              row.minimumpriceDetails.price > 0
                                                ? "#38a169"
                                                : "#e53e3e", // Green for valid, red for invalid prices
                                            marginRight: "8px",
                                          }}
                                        >
                                          {row.minimumpriceDetails.price
                                            ? `$${row.minimumpriceDetails.price}`
                                            : "N/A"}
                                        </Typography>

                                        {row.minimumpriceDetails.price > 0 && (
                                          <Chip
                                            label="Best Price"
                                            color="success"
                                            size="small"
                                            sx={{
                                              fontWeight: "bold",
                                              backgroundColor: "#38a169",
                                              color: "white",
                                            }}
                                          />
                                        )}
                                      </Box>

                                      <Typography
                                        variant="body2"
                                        sx={{
                                          fontSize: "14px",
                                          color: "#4a5568", // Light gray for unit details
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <span>
                                          {row.productTotalUnit}{" "}
                                          {convertUnit(row.variantUnit)}
                                        </span>
                                      </Typography>
                                    </Box>
                                  ) : (
                                    <Typography
                                      variant="body2"
                                      sx={{ color: "#888" }}
                                    >
                                      No minimum price available
                                    </Typography>
                                  )}
                                </TableCell> */}
                                    <TableCell
                                      scope="row"
                                      className={classes.tablCell}
                                    >
                                      {row.minimumpriceDetails ? (
                                        <Box
                                          sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            // alignItems: "flex-start",
                                            padding: "12px",
                                            borderRadius: "10px",
                                            border: "0.5px solid #ffffff",
                                            transition: "0.3s ease-in-out",
                                            "&:hover": {
                                              backgroundColor: "#ffffff",
                                              borderRadius: "10px",
                                              border: "0.5px solid #ffffff",
                                              boxShadow:
                                                "0 4px 12px rgba(0, 0, 0, 0.15)",
                                            },
                                          }}
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                              marginBottom: "8px",
                                            }}
                                          >
                                            <Typography
                                              // variant="body1"
                                              sx={{
                                                fontWeight: "bold",
                                                color: "#1a202c",
                                                // marginBottom: "6px",
                                              }}
                                            >
                                              {getStoreMap.get(
                                                row.minimumpriceDetails.storeId
                                              )}
                                            </Typography>

                                            <Typography
                                              // variant="h6"
                                              style={{
                                                color:
                                                  row.minimumpriceDetails
                                                    .price > 0
                                                    ? "#28a745"
                                                    : "#e53e3e",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              {row.minimumpriceDetails.price
                                                ? `$${row.minimumpriceDetails.price}`
                                                : "N/A"}
                                            </Typography>

                                            <Typography
                                              variant="body2"
                                              style={{
                                                color: "#555",
                                                // fontSize: "15px",
                                              }}
                                            >
                                              {row.productTotalUnit}{" "}
                                              {convertUnit(row.variantUnit)}
                                            </Typography>
                                          </div>

                                          {row.minimumpriceDetails.price >
                                            0 && (
                                            <div
                                              style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                backgroundColor: "#f0f4f8",
                                                padding: "8px",
                                                borderRadius: "8px",
                                                marginTop: "8px",
                                                border: "1px solid #ccc",
                                              }}
                                            >
                                              <Typography
                                                variant="body1"
                                                style={{
                                                  fontWeight: "bold",
                                                  color: "#333",
                                                }}
                                              >
                                                Total Price :
                                              </Typography>

                                              <Typography
                                                variant="body1"
                                                style={{
                                                  fontWeight: "bold",
                                                  color: "#007bff",
                                                }}
                                              >
                                                $
                                                {(
                                                  row.minimumpriceDetails
                                                    .price *
                                                  row.productTotalUnit
                                                ).toFixed(2)}
                                              </Typography>
                                            </div>
                                          )}
                                        </Box>
                                      ) : (
                                        <Typography
                                          variant="body2"
                                          sx={{ color: "#888" }}
                                        ></Typography>
                                      )}
                                    </TableCell>

                                    {/* <TableCell
                                  scope="row"
                                  className={classes.tablCell}
                                >
                                  {row.minimumpriceDetails ? (
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        padding: "12px",
                                        backgroundColor: "#f9f9f9",
                                        borderRadius: "8px",
                                        boxShadow:
                                          "0 2px 4px rgba(0, 0, 0, 0.1)",
                                        border: "1px solid #ddd",
                                        marginBottom: "12px",
                                      }}
                                    >
                                      <Typography
                                        variant="h6"
                                        style={{
                                          fontWeight: "bold",
                                          color: "#333",
                                          marginBottom: "10px",
                                        }}
                                      >
                                        {getStoreMap.get(
                                          row.minimumpriceDetails.storeId
                                        )}
                                      </Typography>

                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                          marginBottom: "8px",
                                        }}
                                      >
                                        <Typography
                                          variant="h6"
                                          style={{
                                            color:
                                              row.minimumpriceDetails.price > 0
                                                ? "#28a745"
                                                : "#e53e3e",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          {row.minimumpriceDetails.price
                                            ? `$${row.minimumpriceDetails.price}`
                                            : "N/A"}
                                        </Typography>

                                        <Typography
                                          variant="body2"
                                          style={{
                                            color: "#555",
                                            fontSize: "14px",
                                          }}
                                        >
                                          {row.productTotalUnit}{" "}
                                          {convertUnit(row.variantUnit)}
                                        </Typography>
                                      </div>

                                      {row.minimumpriceDetails.price > 0 && (
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            backgroundColor: "#f0f4f8",
                                            padding: "8px",
                                            borderRadius: "8px",
                                            marginTop: "8px",
                                            border: "1px solid #ccc",
                                          }}
                                        >
                                          <Typography
                                            variant="body1"
                                            style={{
                                              fontWeight: "bold",
                                              color: "#333",
                                            }}
                                          >
                                            Total Price:
                                          </Typography>

                                          <Typography
                                            variant="body1"
                                            style={{
                                              fontWeight: "bold",
                                              color: "#007bff",
                                            }}
                                          >
                                            $
                                            {row.minimumpriceDetails.price *
                                              row.productTotalUnit}
                                          </Typography>
                                        </div>
                                      )}
                                    </div>
                                  ) : (
                                    <Typography
                                      variant="body2"
                                      style={{ color: "#888" }}
                                    >
                                      No minimum price available
                                    </Typography>
                                  )}
                                </TableCell> */}
                                  </TableRow>
                                )
                              )
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      {selectedProduct && selectedProductData && (
                        <NewPopUpProduct
                          openModel={openDialog}
                          handleCloseDialog={handleCloseDialog}
                          // OrderlistEditProductId={selectedProduct}
                          data={selectedProductData}
                        />
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {/* 
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Grid
                container
                spacing={1}
                justifyContent="flex-end"
                sx={{ display: "flex" }}
              >
                <Grid item>
                  <Button
                    startIcon={<CheckCircleOutlineIcon />}
                    variant="contained"
                    className={classes.addButton}
                    onClick={() => {
                      if (orderListStatus === "OrderListCreated") {
                        handleOpenStatusPopup();
                      } else {
                        handleOpenDialogGenerate();
                      }
                    }}
                  >
                    Confirm
                  </Button>
                </Grid>
              </Grid>
            </Grid> */}
            {coursingToStatus && (
              <StatusPopup
                open={open}
                handleCloseDelete={handleCloseStatusPopup}
                onConfirm={async () => {
                  await handleChangeStatus(
                    String(orderListHistoryId).toString()
                  );
                }}
                title="Confirm Status Change"
                content={`Are you sure you want to change the status to "Manager Approval Pending"? 
              Once updated, this action cannot be undone. 
              Order ID: ${ReDateId}`}
              />
            )}

            <Dialog
              open={openOrderListDate}
              onClose={handleCloseDialogGenerate}
              sx={{ padding: 5, minWidth: 450 }}
            >
              <Grid className={classes.Dialog}>
                <form onSubmit={formik.handleSubmit}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      alignContent={"center"}
                    >
                      <Typography className={classes.cardTitle}>
                        Confirm Action
                      </Typography>
                    </Grid>
                  </Grid>
                  <DialogContent>
                    <DialogContentText sx={{ pt: 3 }}>Status</DialogContentText>
                    <Grid container alignItems="center">
                      <Grid item lg={12} md={12} sm={12} xs={12} pt={1}>
                        <TextField
                          select
                          size="small"
                          className={classes.textField}
                          SelectProps={{
                            native: false,
                          }}
                          defaultValue=""
                          InputLabelProps={{ shrink: true }}
                          {...formik.getFieldProps("status")}
                        >
                          <MenuItem value="" disabled>
                            Select some option
                          </MenuItem>

                          {Object.entries(OrderListStatus).map(
                            ([key, value], index) => (
                              <MenuItem key={index} value={value}>
                                {convertStatus(key)}
                              </MenuItem>
                            )
                          )}
                        </TextField>
                      </Grid>
                    </Grid>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      variant="outlined"
                      startIcon={<CloseIcon />}
                      className={classes.addButton}
                      onClick={handleCloseDialogGenerate}
                    >
                      Cancel
                    </Button>
                    <Box m={0.5}></Box>

                    <Button
                      variant="contained"
                      startIcon={<CheckCircleOutlineIcon />}
                      className={classes.addButton}
                      onClick={() => formik.handleSubmit()}
                      disabled={!formValid || isLoading}
                    >
                      Confirm
                    </Button>
                  </DialogActions>
                </form>
              </Grid>
            </Dialog>
          </Grid>
        </Card>
      </Grid>
      <Grid item lg={4} md={12} sm={12} xs={12}>
        <Card className={classes.stepperCard5}>
          <Grid container spacing={2} p={2}>
            <Grid item lg={12} md={12} sm={12} xs={12} mb={2}>
              <Typography
                variant="subtitle1"
                textAlign={"right"}
                className={classes.cardTitle256}
                sx={{ color: "#f0f4f8" }}
              >
                Order List : {ReDateId}
              </Typography>
              <Typography textAlign={"right"} sx={{ color: "#f0f4f8" }}>
                {"Create By : "}
                {userMap.get(createBy) || ""}
              </Typography>
              <Typography textAlign={"right"} sx={{ color: "#f0f4f8" }}>
                {"Create At : "}
                {dayjs(createAt).format("YYYY-MM-D hh:mm A") || ""}
              </Typography>
              <Typography
                className={classes.primaryHeading12}
                textAlign={"right"}
              >
                {convertStatus(orderListStatus || "")}
              </Typography>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12} mt={1}>
              <Grid container spacing={3} mt={3}>
                {Object.entries(groupedData).map(([storeId, orders]) => {
                  const storeName =
                    storeId === undefined || storeId === null
                      ? "Update Items Price to Store"
                      : getStoreMap.get(Number(storeId)) || "Store Not Found";

                  return (
                    <Grid item lg={12} md={12} sm={12} xs={12} key={storeId}>
                      <Card
                        sx={{
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          boxShadow: 4,
                          borderRadius: 3,
                          transition: "0.3s",
                          "&:hover": { boxShadow: 8, transform: "scale(1.03)" },
                        }}
                      >
                        <CardContent
                          sx={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <Typography
                            fontWeight="bold"
                            color="primary"
                            textAlign="center"
                            gutterBottom
                            className={classes.primaryHeading}
                          >
                            {storeName}
                          </Typography>

                          <List sx={{ flexGrow: 1 }}>
                            {orders.map((order, index) => (
                              <React.Fragment key={order.id}>
                                <ListItem
                                  sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    px: 2,
                                    py: 1,
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontWeight: "bold",
                                      color: "#1a202c",
                                      flex: 1,
                                      textAlign: "left",
                                    }}
                                  >
                                    {order.variantName}
                                  </Typography>

                                  <Typography
                                    sx={{
                                      color: "#28a745",
                                      fontWeight: "bold",
                                      flex: 1,
                                      textAlign: "center",
                                    }}
                                  >
                                    {order.minimumpriceDetails?.price
                                      ? `$${order.minimumpriceDetails.price}`
                                      : "N/A"}
                                  </Typography>

                                  <Typography
                                    variant="body2"
                                    sx={{
                                      color: "#555",
                                      flex: 1,
                                      textAlign: "right",
                                    }}
                                  >
                                    {order.productTotalUnit}{" "}
                                    {convertUnit(order.variantUnit)}
                                  </Typography>
                                </ListItem>

                                {index !== orders.length - 1 && <Divider />}
                              </React.Fragment>
                            ))}
                          </List>
                        </CardContent>
                      </Card>
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container spacing={2} alignItems="center">
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Grid
                    container
                    spacing={1}
                    justifyContent="flex-end"
                    sx={{ display: "flex" }}
                  >
                    <Grid item>
                      <Button
                        startIcon={<TableViewIcon />}
                        className={classes.addButtonPdfExcel}
                        // onClick={handleExportToExcel}
                      >
                        Excel
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        startIcon={<LocalPrintshopSharpIcon />}
                        className={classes.addButtonPdfExcel}
                        // onClick={handleExportToPDF}
                      >
                        pdf
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {/* <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Grid
                container
                spacing={1}
                justifyContent="flex-end"
                sx={{ display: "flex" }}
              >
                <Grid item>
                  <Button
                    startIcon={<CheckCircleOutlineIcon />}
                    variant="contained"
                    className={classes.addButton}
                    onClick={() => {
                      if (orderListStatus === "OrderListCreated") {
                        handleOpenStatusPopup();
                      } else {
                        handleOpenDialogGenerate();
                      }
                    }}
                  >
                    Confirm
                  </Button>
                </Grid>
              </Grid>
            </Grid> */}
          </Grid>
        </Card>
      </Grid>
    </Grid>
  );
};

export default Index;
